<template>
  <b-row style="position: relative">
    <div
      v-if="isApprove"
      class="position-absolute"
      style="top: -10px; right: 20px; z-index: 1"
    >
      <i
        v-if="!selectedItem?.isApprove"
        class="fa fa-close text-danger"
        style="font-size: 40px"
      ></i>
      <i v-else class="fa fa-check text-success" style="font-size: 40px"></i>
    </div>
    <b-col md="2" class="mb-3 text-gray"> Equipment Name </b-col>
    <b-col md="4">{{
      selectedItem.name != 'Others'
        ? selectedItem.name
        : selectedItem.other_name ?? '-'
    }}</b-col>
    <b-col md="2" class="mb-3 text-gray"> Kind of Task </b-col>
    <b-col md="4">{{
      findText(optionsKindTask, selectedItem.kind_task_id)
    }}</b-col>
    <b-col md="2" class="mb-3 text-gray"> Work Item</b-col>
    <b-col md="4">{{ selectedItem?.title }}</b-col>
    <b-col md="2" class="mb-3 text-gray"> Est. Start Date </b-col>
    <b-col md="4">
      {{ moment(selectedItem.start_at).format('DD MMM YYYY') }}
    </b-col>
    <b-col md="2" class="mb-3 text-gray">Type R & M</b-col>
    <b-col md="4">
      {{ findText(optionsTaskType, selectedItem.task_type_id) }}
    </b-col>
    <b-col md="2" class="mb-3 text-gray">Est. Finish Date</b-col>
    <b-col md="4">{{
      moment(selectedItem.estimated_finished_at).format('DD MMM YYYY')
    }}</b-col>
    <b-col md="2" class="mb-3 text-gray"> Department </b-col>
    <b-col md="4">
      {{ findText(optionsDepartment, selectedItem.department_id) }}
    </b-col>
    <b-col md="2" class="mb-3 text-gray">Est. Cost Item Repair </b-col>
    <b-col md="4" v-if="editable">
      <InputCurrency v-model="selectedItem.cost_estimate" />
    </b-col>
    <b-col md="4" v-else>
      {{ formatCurrency(selectedItem.cost_estimate) }}
    </b-col>
    <b-col md="2" class="mb-3 text-gray">Repair Section</b-col>
    <b-col md="4">{{ selectedItem.section }}</b-col>
    <template v-if="selectedItem.status?.name == 'Finish'">
      <b-col md="2" class="mb-3 text-gray">Real Cost Item Repair </b-col>
      <b-col md="4">
        {{ formatCurrency(selectedItem.cost_real) }}
      </b-col>
    </template>
    <!-- <b-col md="4" v-if="isApprove">
      <b-input-group prepend="Rp">
        <b-form-input required type="number" class="bg-white" v-model="selectedItem.cost_real"></b-form-input>
      </b-input-group>
      <small> {{ formatCurrency(selectedItem.cost_real) }}</small>
    </b-col>
    <b-col md="4" v-else>
      {{ formatCurrency(selectedItem.cost_real) }}
    </b-col> -->
    <b-col md="2" class="mb-3 text-gray">Category</b-col>
    <b-col md="4">
      {{ findText(optionsCategory, selectedItem.category_id) }}
    </b-col>
    <b-col md="2" class="mb-3 text-gray">Classification</b-col>
    <b-col md="4">
      {{ findText(optionsClassification, selectedItem.classification_id) }}
    </b-col>
    <b-col md="2" class="mb-3 text-gray">Attachment</b-col>
    <b-col md="4">
      <div
        style="max-width: 200px"
        class="p-0 pr-2 pb-2"
        v-for="(url, idx) in selectedItem.filePreview"
        :key="`${idx}`"
      >
        <AttachmentSR
          :modelId="selectedItem.id"
          modelName="sr_form_repair"
          :url="(url?.id ? apiUrl : '') + url?.path ?? url?.url"
          :file="url"
          @delete="() => handleDeleteFile(selectedItem, idx)"
          :isPreview="true"
        />
      </div>
    </b-col>
    <b-col md="2" class="mb-3 text-gray">Cause</b-col>
    <b-col md="4">
      {{ findText(optionsCause, selectedItem.case_id) }}
    </b-col>
    <b-col md="2" class="mb-3 text-gray">Remarks</b-col>
    <b-col md="4">
      {{ selectedItem.description }}
    </b-col>
    <b-col v-if="isApprove" md="12" class="d-flex justify-content-end">
      <b-button
        type="button"
        variant="danger"
        v-if="selectedItem.isApprove"
        class="mr-2"
        @click="selectedItem.isApprove = false"
      >
        <i class="fa fa-close"></i> Reject
      </b-button>
      <b-button
        type="button"
        variant="success"
        v-else
        @click="selectedItem.isApprove = true"
      >
        <i class="fa fa-thumbs-up"></i> Approve
      </b-button>
    </b-col>
  </b-row>
</template>
<script>
import moment from '@/node_modules/moment/moment'
import AttachmentSR from './AttachmentSR.vue'
import InputCurrency from '@/src/components/global/InputCurrency.vue'
export default {
  props: {
    editable: Boolean,
    isApprove: Boolean,
    selectedItem: {
      type: Object,
      default: () => {},
    },
    optionsTaskType: {
      type: Array,
      default: () => [],
    },
    optionsDepartment: {
      type: Array,
      default: () => [],
    },
    optionsCategory: {
      type: Array,
      default: () => [],
    },
    optionsClassification: {
      type: Array,
      default: () => [],
    },
    optionsCause: {
      type: Array,
      default: () => [],
    },
    optionsKindTask: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      apiUrl: `${process.env.VUE_APP_API_BASE_URL}/sr/`,
    }
  },
  components: {
    AttachmentSR,
    InputCurrency
  },
  methods: {
    findText(options, id) {
      return options.find((el) => el?.value == id)?.text
    },
    formatCurrency(value) {
      return new Intl.NumberFormat('id-ID', {
        style: 'currency',
        currency: 'IDR',
      }).format(value)
    },
    handleDeleteFile(item, idx) {
      const newFiles = item.filePreview.filter((_, i) => i !== idx)
      const newFileUploads = item.file.filter((_, i) => i !== idx)
      item.filePreview = newFiles
      item.file = newFileUploads
    },
  },
}
</script>
<style></style>
